import { useApiGetDirectorMessage } from 'core/api/director/useApiGetDirectorMessage'
import { useContext } from 'react'
import { HomeContext } from '../../state/home-context'
import Alert, { IconOptions } from 'components/common/alert/alert'
import { useTranslation } from 'react-i18next'

const StoreDirectorMessage = () => {
  const { t } = useTranslation()
  const { storeId } = useContext(HomeContext)
  const { data, isLoading } = useApiGetDirectorMessage(storeId, { enabled: !!storeId })

  const iconOptions: IconOptions = {
    name: 'message',
    style: 'LINE'
  }
  return !isLoading && data ? (
    <Alert
      text={`${t('general.homepage.store-director-message.alert.intro')} ${data}`}
      icon={iconOptions}
      severity="info"
      closable={false}
    />
  ) : null
}

export default StoreDirectorMessage
